/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1);
	
	__webpack_require__(13);
	
	var _init = __webpack_require__(15);
	
	var _init2 = _interopRequireDefault(_init);
	
	var _floatLabel = __webpack_require__(22);
	
	var _floatLabel2 = _interopRequireDefault(_floatLabel);
	
	var _formValidator = __webpack_require__(23);
	
	var _formValidator2 = _interopRequireDefault(_formValidator);
	
	var _sticky = __webpack_require__(24);
	
	var _sticky2 = _interopRequireDefault(_sticky);
	
	var _scrollMarker = __webpack_require__(25);
	
	var _scrollMarker2 = _interopRequireDefault(_scrollMarker);
	
	var _swiper = __webpack_require__(26);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	var _lightbox = __webpack_require__(27);
	
	var _lightbox2 = _interopRequireDefault(_lightbox);
	
	var _map = __webpack_require__(28);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _parallax = __webpack_require__(31);
	
	var _parallax2 = _interopRequireDefault(_parallax);
	
	var _scrollFader = __webpack_require__(32);
	
	var _scrollFader2 = _interopRequireDefault(_scrollFader);
	
	var _notification = __webpack_require__(33);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Lum.register(_floatLabel2.default);
	Lum.register(_formValidator2.default);
	Lum.register(_sticky2.default);
	Lum.register(_scrollMarker2.default);
	Lum.register(_swiper2.default);
	Lum.register(_lightbox2.default);
	Lum.register(_map2.default);
	Lum.register(_parallax2.default);
	Lum.register(_scrollFader2.default);
	Lum.register(_notification2.default);
	
	(0, _init2.default)();

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lum = __webpack_require__(2);
	
	var _lum2 = _interopRequireDefault(_lum);
	
	var _config = __webpack_require__(3);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _toggler = __webpack_require__(4);
	
	var _toggler2 = _interopRequireDefault(_toggler);
	
	var _selector = __webpack_require__(12);
	
	var _selector2 = _interopRequireDefault(_selector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_lum2.default.config = _config2.default;
	
	_lum2.default.register(_toggler2.default);
	_lum2.default.register(_selector2.default);
	
	window.Lum = _lum2.default;

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		version: '0.2.1',
	
		register: function register(module) {
			this._baseModules.push(module);
		},
	
		start: function start() {
			var container = arguments.length <= 0 || arguments[0] === undefined ? document : arguments[0];
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;
	
			try {
				for (var _iterator = this._baseModules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var Module = _step.value;
	
					Module.start(container);
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		},
	
		_baseModules: []
	};

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		directivePrefix: ''
	};

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _element = __webpack_require__(5);
	
	var Element = _interopRequireWildcard(_element);
	
	var _base = __webpack_require__(6);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _action = __webpack_require__(10);
	
	var _action2 = _interopRequireDefault(_action);
	
	var _class = __webpack_require__(11);
	
	var _class2 = _interopRequireDefault(_class);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = _base2.default.extend({
		directive: 'toggler',
	
		modules: {
			actions: _action2.default,
			classes: _class2.default
		},
	
		defaults: {
			is: 'open',
			transition: false,
			classOpen: 'is-open',
			classClosed: 'is-closed',
			classOpening: 'is-opening',
			classClosing: 'is-closing'
		},
	
		events: {
	
			init: function init() {
				var _this = this;
	
				var Module = this.constructor;
	
				this.toggle(this.$settings.is === 'open', false);
	
				if (this.$settings.transition === true) {
					this.$element.addEventListener('transitionend', function (e) {
						if (e.target === _this.$element) {
							Module.trigger('transitionEnd', { target: _this });
						}
					});
				}
			},
	
			transitionStart: function transitionStart() {
				var classes = this.$element.classList;
	
				if (this.showing) {
					classes.remove(this.$settings.classClosed);
					classes.add(this.$settings.classClosing);
	
					Element.repaint(this.$element);
	
					classes.remove(this.$settings.classClosing);
					classes.add(this.$settings.classOpening);
				} else {
					classes.remove(this.$settings.classOpen);
					classes.add(this.$settings.classOpening);
	
					Element.repaint(this.$element);
	
					classes.remove(this.$settings.classOpening);
					classes.add(this.$settings.classClosing);
				}
			},
	
			transitionEnd: function transitionEnd() {
				var classes = this.$element.classList;
	
				if (this.showing) {
					classes.remove(this.$settings.classOpening);
					classes.add(this.$settings.classOpen);
				} else {
					classes.remove(this.$settings.classClosing);
					classes.add(this.$settings.classClosed);
				}
			}
		},
	
		methods: {
	
			toggle: function toggle(isOpen) {
				var transition = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
				var Module = this.constructor;
				var classes = this.$element.classList;
	
				var oldShowing = this.showing;
				var newShowing = typeof isOpen === 'boolean' ? isOpen : !this.showing;
	
				if (oldShowing !== newShowing) {
					this.showing = newShowing;
	
					if (transition && this.$settings.transition) {
						Module.trigger('transitionStart', { target: this });
					} else {
						classes.remove(this.$settings.classClosing, this.$settings.classOpening);
						classes.toggle(this.$settings.classOpen, this.showing);
						classes.toggle(this.$settings.classClosed, !this.showing);
					}
	
					this.trigger('change', {
						property: 'selected',
						oldValue: oldShowing,
						newValue: newShowing
					});
	
					Module.trigger('toggle', {
						target: this,
						transition: transition
					});
				}
			},
	
			open: function open() {
				var transition = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
				this.toggle(true, transition);
			},
	
			close: function close() {
				var transition = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
				this.toggle(false, transition);
			},
	
			isOpen: function isOpen() {
				return this.showing;
			},
	
			isClosed: function isClosed() {
				return !this.showing;
			}
		}
	});

/***/ },
/* 5 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.closest = closest;
	exports.data = data;
	exports.repaint = repaint;
	function closest(element, selector) {
		if (element.closest) {
			return element.closest(selector);
		}
	
		var currentElement = element;
		while (currentElement) {
			if (currentElement.matches(selector)) {
				return currentElement;
			}
	
			currentElement = currentElement.parentElement;
		}
	
		return null;
	}
	
	var expando = "lum-" + Date.now().toString(36) + "_";
	function data(element, property, value) {
		var expandoProperty = expando + property;
	
		if (value !== undefined) {
			element[expandoProperty] = value;
		}
	
		return element[expandoProperty];
	}
	
	function repaint() {
		var element = arguments.length <= 0 || arguments[0] === undefined ? document.body : arguments[0];
	
		element.offsetTop;
	}

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _config = __webpack_require__(3);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _emitter = __webpack_require__(7);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _element = __webpack_require__(5);
	
	var Element = _interopRequireWildcard(_element);
	
	var _parser = __webpack_require__(8);
	
	var Parser = _interopRequireWildcard(_parser);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Base = function (_Emitter) {
		_inherits(Base, _Emitter);
	
		_createClass(Base, null, [{
			key: 'getDirective',
			value: function getDirective() {
				var owner = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
	
				var Module = this;
				var d = Module.directive;
	
				if (owner) {
					var OwnerModule = owner.constructor;
					var od = OwnerModule.getDirective(owner.$owner);
	
					return od + '-' + d;
				}
	
				return d;
			}
		}, {
			key: 'getSelector',
			value: function getSelector() {
				var owner = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
	
				var Module = this;
	
				var p = _config2.default.directivePrefix;
				var d = Module.getDirective(owner);
				var selector = ['[' + p + d + ']'];
	
				if (owner) {
					var ref = owner.$element.getAttribute(p + 'ref');
					selector.push('[' + p + d + '\\:' + ref + ']');
				}
	
				return selector.join(',');
			}
		}, {
			key: 'getSettings',
			value: function getSettings(element) {
				var owner = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
				var Module = this;
	
				var p = _config2.default.directivePrefix;
				var d = Module.getDirective(owner);
				var ref = Module.getReference(element, owner);
				var settings = '';
	
				if (ref) {
					settings = element.getAttribute('' + p + d + ':' + ref);
				} else {
					settings = element.getAttribute('' + p + d) || element.getAttribute(d);
				}
	
				return Parser.settings(settings);
			}
		}, {
			key: 'getReference',
			value: function getReference(element) {
				var owner = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
				var Module = this;
	
				var p = _config2.default.directivePrefix;
				var d = Module.getDirective(owner);
	
				if (!element.hasAttribute('' + p + d) && owner) {
					var ref = owner.$element.getAttribute(p + 'ref');
					var hasRef = element.hasAttribute('' + p + d + ':' + ref);
	
					if (hasRef) {
						return ref;
					}
				}
	
				return null;
			}
		}, {
			key: 'trigger',
			value: function trigger(eventType) {
				var data = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
				var Module = this;
				var ExtendedModule = Module.extending;
				var eventFn = Module.events[eventType];
	
				if (eventFn) {
					eventFn.call(data.target, data);
				}
	
				if (ExtendedModule) {
					ExtendedModule.trigger(eventType, data);
				}
			}
		}, {
			key: 'extend',
			value: function extend(settings) {
				var SuperModule = this;
				var Module = function Module() {
					SuperModule.apply(this, arguments);
				};
	
				Module.prototype = new SuperModule();
	
				if (settings.methods) {
					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;
	
					try {
						for (var _iterator = Object.keys(settings.methods)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var name = _step.value;
	
							var method = settings.methods[name];
							Module.prototype[name] = method;
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}
				}
	
				Module.prototype.constructor = Module;
	
				Module.getDirective = SuperModule.getDirective;
				Module.getSelector = SuperModule.getSelector;
				Module.getSettings = SuperModule.getSettings;
				Module.getReference = SuperModule.getReference;
				Module.trigger = SuperModule.trigger;
				Module.extend = SuperModule.extend;
				Module.start = SuperModule.start;
	
				Module.extending = SuperModule;
				Module.directive = settings.directive;
				Module.modules = Object.assign({}, SuperModule.modules, settings.modules);
				Module.defaults = Object.assign({}, SuperModule.defaults, settings.defaults);
				Module.methods = Module.prototype;
				Module.events = settings.events || {};
	
				return Module;
			}
		}, {
			key: 'start',
			value: function start() {
				var container = arguments.length <= 0 || arguments[0] === undefined ? document : arguments[0];
				var owner = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
				var Module = this;
				var elements = container.querySelectorAll(Module.getSelector(owner));
				var modules = [];
	
				var p = _config2.default.directivePrefix;
	
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;
	
				try {
					for (var _iterator2 = Array.from(elements)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var element = _step2.value;
	
						if (owner && !Module.getReference(element, owner)) {
							var OwnerModule = owner.constructor;
							var ownerElement = Element.closest(element, OwnerModule.getSelector(owner.$owner));
							if (ownerElement !== owner.$element) {
								continue;
							}
						}
	
						var settings = Module.getSettings(element, owner);
						var e = {
							element: element,
							settings: settings
						};
	
						Module.trigger('beforeInit', e);
	
						var module = new Module(e.element, e.settings, owner);
	
						var _iteratorNormalCompletion3 = true;
						var _didIteratorError3 = false;
						var _iteratorError3 = undefined;
	
						try {
							for (var _iterator3 = Object.keys(Module.modules)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
								var property = _step3.value;
	
								var SubModule = Module.modules[property];
								var subModules = SubModule.start(container, module);
	
								module.$owns[property] = subModules;
							}
						} catch (err) {
							_didIteratorError3 = true;
							_iteratorError3 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion3 && _iterator3.return) {
									_iterator3.return();
								}
							} finally {
								if (_didIteratorError3) {
									throw _iteratorError3;
								}
							}
						}
	
						module.$element.removeAttribute(p + 'cloak');
	
						Module.trigger('init', { target: module });
	
						modules.push(module);
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
	
				return modules;
			}
		}]);
	
		function Base(element) {
			var settings = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
			var owner = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
			_classCallCheck(this, Base);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Base).call(this));
	
			_emitter2.default.call(_this);
	
			if (!element) return _possibleConstructorReturn(_this);
	
			var Module = _this.constructor;
	
			_this.$element = element;
			_this.$owner = owner;
			_this.$owns = {};
			_this.$settings = Object.assign({}, Module.defaults, settings);
	
			Element.data(element, Module.getDirective(owner), _this);
			return _this;
		}
	
		return Base;
	}(_emitter2.default);
	
	exports.default = Base;
	
	
	Base.directive = null;
	Base.modules = {};
	Base.defaults = {};
	Base.methods = Base.prototype;
	Base.events = {};

/***/ },
/* 7 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class() {
			_classCallCheck(this, _class);
	
			this.events = {};
		}
	
		_createClass(_class, [{
			key: "on",
			value: function on(type, callback) {
				if (!this.events.hasOwnProperty(type)) {
					this.events[type] = [];
				}
	
				this.events[type].push(callback);
			}
		}, {
			key: "off",
			value: function off(type) {
				var callback = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
				if (callback && this.events.hasOwnProperty(type)) {
					var newList = [];
					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;
	
					try {
						for (var _iterator = this.events[type][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var cb = _step.value;
	
							if (cb !== callback) {
								newList.push(cb);
							}
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}
	
					this.events[type] = newList;
				} else {
					delete this.events[type];
				}
			}
		}, {
			key: "trigger",
			value: function trigger(type) {
				var event = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
				if (this.events.hasOwnProperty(type)) {
					event.type = type;
	
					var _iteratorNormalCompletion2 = true;
					var _didIteratorError2 = false;
					var _iteratorError2 = undefined;
	
					try {
						for (var _iterator2 = this.events[type][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
							var cb = _step2.value;
	
							cb.call(this, event);
						}
					} catch (err) {
						_didIteratorError2 = true;
						_iteratorError2 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion2 && _iterator2.return) {
								_iterator2.return();
							}
						} finally {
							if (_didIteratorError2) {
								throw _iteratorError2;
							}
						}
					}
				}
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.settings = settings;
	exports.value = value;
	exports.method = method;
	
	var _method = __webpack_require__(9);
	
	var _method2 = _interopRequireDefault(_method);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function settings() {
		var string = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
	
		string = typeof string === 'string' ? string : '';
	
		if (string[0] === '{') {
			return JSON.parse(string);
		}
	
		var parsed = {};
	
		var parts = string.trim().split(/\s+/);
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;
	
		try {
			for (var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var part = _step.value;
	
				var item = part.split(':');
				var setting = item[0];
	
				parsed[setting] = item.length > 1 ? value(item[1]) : true;
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	
		return parsed;
	}
	
	function value(data) {
		if (!isNaN(data)) {
			return parseFloat(data);
		}
	
		if (data === 'true') {
			return true;
		}
	
		if (data === 'false') {
			return false;
		}
	
		return data;
	}
	
	function method(data) {
		if (typeof data === 'string') {
			var eventMethod = data;
			var methodParts = eventMethod.split('|');
			var methodName = methodParts[0];
			var methodArgs = methodParts[1] ? methodParts[1].split('') : [];
	
			for (var i = 0; i < methodArgs.length; i++) {
				methodArgs[i] = value(methodArgs[i]);
			}
	
			return new _method2.default(methodName, methodArgs);
		}
	
		return data;
	}

/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		function _class(name) {
			var args = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
	
			_classCallCheck(this, _class);
	
			this.name = name;
			this.args = args;
		}
	
		_createClass(_class, [{
			key: 'run',
			value: function run(target) {
				var source = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
				source = source || target;
	
				var value = void 0;
				var e = {
					name: this.name,
					args: this.args,
					caller: source
				};
	
				target.trigger('methodCall', e);
	
				if (typeof target[e.name] === 'function') {
					value = target[e.name].apply(target, e.args);
				} else {
					value = target[this.name];
				}
	
				e = {
					name: e.name,
					args: e.args,
					value: value,
					caller: source
				};
	
				target.trigger('methodReturn', e);
	
				return e.value;
			}
		}]);

		return _class;
	}();

	exports.default = _class;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _lum = __webpack_require__(2);
	
	var _lum2 = _interopRequireDefault(_lum);
	
	var _base = __webpack_require__(6);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _parser = __webpack_require__(8);
	
	var Parser = _interopRequireWildcard(_parser);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _base2.default.extend({
		directive: 'action',
	
		events: {
	
			beforeInit: function beforeInit(e) {
				var newSettings = {};
	
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = Object.keys(e.settings)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var setting = _step.value;
	
						var value = e.settings[setting];
						var eventType = setting;
						var eventMethod = value;
	
						if (value === true) {
							eventType = 'click';
							eventMethod = setting;
						}
	
						if (!newSettings.hasOwnProperty(eventType)) {
							newSettings[eventType] = [];
						}
	
						newSettings[eventType].push(Parser.method(eventMethod));
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
	
				e.settings = newSettings;
			},
	
			init: function init() {
				var _this = this;
	
				var settings = this.$settings;
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;
	
				try {
					var _loop = function _loop() {
						var eventType = _step2.value;
	
						settings[eventType].forEach(function (method) {
							_this.$element.addEventListener(eventType, function (e) {
								e.preventDefault();
								method.run(_this.$owner, _this);
							});
						});
					};
	
					for (var _iterator2 = Object.keys(settings)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						_loop();
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
			}
		}
	});

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _lum = __webpack_require__(2);
	
	var _lum2 = _interopRequireDefault(_lum);
	
	var _base = __webpack_require__(6);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _parser = __webpack_require__(8);
	
	var Parser = _interopRequireWildcard(_parser);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _base2.default.extend({
		directive: 'class',
	
		events: {
	
			beforeInit: function beforeInit(e) {
				var newSettings = {};
	
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = Object.keys(e.settings)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var setting = _step.value;
	
						var value = e.settings[setting];
						var className = setting;
						var eventMethod = value;
	
						newSettings[className] = Parser.method(eventMethod);
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
	
				e.settings = newSettings;
			},
	
			init: function init() {
				var _this = this;
	
				var settings = this.$settings;
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;
	
				try {
					var _loop = function _loop() {
						var className = _step2.value;
	
						var method = settings[className];
	
						_this.$owner.on('change', function (e) {
							var toggle = method.run(_this.$owner);
							_this.$element.classList.toggle(className, toggle);
						});
					};
	
					for (var _iterator2 = Object.keys(settings)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						_loop();
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
			}
		}
	});

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _element = __webpack_require__(5);
	
	var Element = _interopRequireWildcard(_element);
	
	var _base = __webpack_require__(6);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _toggler = __webpack_require__(4);
	
	var _toggler2 = _interopRequireDefault(_toggler);
	
	var _action = __webpack_require__(10);
	
	var _action2 = _interopRequireDefault(_action);
	
	var _class = __webpack_require__(11);
	
	var _class2 = _interopRequireDefault(_class);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = _base2.default.extend({
		directive: 'selector',
	
		modules: {
			actions: _action2.default,
			classes: _class2.default,
			items: _toggler2.default.extend({ directive: 'item' })
		},
	
		defaults: {
			selected: 0,
			interval: 0,
			classSelected: 'is-selected'
		},
	
		events: {
	
			init: function init() {
				var Module = this.constructor;
	
				this.select(this.$settings.selected | 0, false);
	
				if (this.$settings.interval > 0) {
					this.play();
				} else {
					this.stop();
				}
			}
		},
	
		methods: {
	
			select: function select(index) {
				var transition = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
				var oldSelected = this.selected;
				var newSelected = index | 0;
	
				if (oldSelected !== newSelected) {
					this.selected = newSelected;
	
					for (var i = 0; i < this.$owns.items.length; i++) {
						var item = this.$owns.items[i];
	
						item.toggle(i === newSelected, transition);
						item.$element.classList.toggle(this.$settings.classSelected, i === newSelected);
					}
	
					this.trigger('change', {
						property: 'selected',
						oldValue: oldSelected,
						newValue: newSelected
					});
				}
			},
	
			go: function go() {
				var count = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
				var transition = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
				var total = this.$owns.items.length;
				var selected = (this.selected + count) % total;
	
				if (selected < 0) {
					selected += total;
				}
	
				this.select(selected, transition);
			},
	
			next: function next() {
				var transition = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
				this.go(1, transition);
			},
	
			previous: function previous() {
				var transition = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
				this.go(-1, transition);
			},
	
			play: function play() {
				var _this = this;
	
				var interval = arguments.length <= 0 || arguments[0] === undefined ? this.$settings.interval : arguments[0];
	
				this._interval = setInterval(function () {
					return _this.next();
				}, interval | 0);
	
				this.trigger('change', {
					property: 'interval',
					oldValue: false,
					newValue: true
				});
			},
	
			stop: function stop() {
				clearInterval(this._interval);
				this._interval = false;
	
				this.trigger('change', {
					property: 'interval',
					oldValue: true,
					newValue: false
				});
			},
	
			isSelected: function isSelected(index) {
				return this.selected === index;
			},
	
			isFirst: function isFirst() {
				return this.isSelected(0);
			},
	
			isLast: function isLast() {
				return this.isSelected(this.$owns.items.length - 1);
			},
	
			isPlaying: function isPlaying() {
				return this._interval !== false;
			}
		}
	});

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _toggler = __webpack_require__(4);
	
	var _toggler2 = _interopRequireDefault(_toggler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_toggler2.default.events.toggle = function (e) {
		if (!e.transition && this.$settings.transition === 'height') {
			this.$element.style.display = this.showing ? '' : 'none';
		}
	};
	
	var superTransitionStart = _toggler2.default.events.transitionStart;
	_toggler2.default.events.transitionStart = function () {
		superTransitionStart.call(this);
	
		var Module = this.constructor;
	
		if (this.$settings.transition === 'height') {
			var $element = (0, _jquery2.default)(this.$element);
			var complete = function () {
				Module.trigger('transitionEnd', { target: this });
			}.bind(this);
	
			if (this.showing) {
				$element.slideDown(400, complete);
			} else {
				$element.slideUp(400, complete);
			}
		}
	};

/***/ },
/* 14 */
/***/ function(module, exports) {

	module.exports = jQuery;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		var context = arguments.length <= 0 || arguments[0] === undefined ? document.body : arguments[0];
	
		(0, _links2.default)(context);
		(0, _scroll2.default)(context);
		(0, _image2.default)(context);
		(0, _autosize2.default)(context);
	
		_lum2.default.start(context);
	};
	
	var _lum = __webpack_require__(2);
	
	var _lum2 = _interopRequireDefault(_lum);
	
	var _links = __webpack_require__(16);
	
	var _links2 = _interopRequireDefault(_links);
	
	var _scroll = __webpack_require__(17);
	
	var _scroll2 = _interopRequireDefault(_scroll);
	
	var _image = __webpack_require__(18);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _autosize = __webpack_require__(20);
	
	var _autosize2 = _interopRequireDefault(_autosize);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		var context = arguments.length <= 0 || arguments[0] === undefined ? document.body : arguments[0];
	
		var $context = (0, _jquery2.default)(context);
	
		// Forces new window clicks for asset files
		$context.find('a').each(function () {
			var $this = (0, _jquery2.default)(this);
			var href = String($this.attr('href')).toLowerCase();
	
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;
	
			try {
				for (var _iterator = assetExtensions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var ext = _step.value;
	
					if (endsWith(href, '.' + ext)) {
						$this.attr('target', '_blank');
						break;
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		});
	
		// Force no focusing on links just clicked. This ensures no focus outline shows up after clicking.
		$context.find('a, button').on('click', function () {
			(0, _jquery2.default)(this).trigger('blur');
		});
	};
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @see https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
	 * @param subjectString
	 * @param searchString
	 * @param position
	 * @returns {boolean}
	 */
	function endsWith(subjectString, searchString, position) {
		if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
			position = subjectString.length;
		}
	
		position -= searchString.length;
	
		var lastIndex = subjectString.indexOf(searchString, position);
		return lastIndex !== -1 && lastIndex === position;
	}
	
	var assetExtensions = 'png jpg jpeg gif doc docx xls xlsx pdf ppt pptx'.split(' ');

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		var context = arguments.length <= 0 || arguments[0] === undefined ? document.body : arguments[0];
	
		var $context = (0, _jquery2.default)(context);
	
		$context.find('[data-scroll]').on('click', scrollClick);
		bindScroll();
	};
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var body = (0, _jquery2.default)('html, body');
	var docEl = document.documentElement;
	
	var breakable = true;
	var breakTimeout = null;
	var bound = false;
	
	function scrollClick(e) {
		e.preventDefault();
	
		clearInterval(breakTimeout);
		breakable = false;
		breakTimeout = setTimeout(function () {
			breakable = true;
		}, 100);
	
		var scroll = (0, _jquery2.default)(this).data('scroll');
		var top = 0;
	
		switch (scroll) {
			case 'top':
				top = 0;break;
			case 'bottom':
				top = docEl.scrollHeight - docEl.clientHeight;break;
			default:
				top = (0, _jquery2.default)(scroll).offset().top;
		}
	
		body.animate({ scrollTop: Math.min(top, docEl.scrollHeight - docEl.clientHeight) }, { duration: 500 });
	}
	
	function bodyScroll(e) {
		if (breakable && e.which > 0) {
			switch (e.type) {
				case 'mousedown':
				case 'mousewheel':
				case 'touchstart':
					body.stop();
					break;
			}
		}
	}
	
	function bindScroll() {
		if (!bound) {
			body.bind('scroll mousedown DOMMouseScroll mousewheel keyup touchstart', bodyScroll);
			bound = true;
		}
	}

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		var context = arguments.length <= 0 || arguments[0] === undefined ? document.body : arguments[0];
	
		var $context = (0, _jquery2.default)(context);
		var counter = 0;
	
		$context.find('img:not([data-src])').each(ready);
		$context.find('[data-image], img[data-src]').each(function () {
			var $element = (0, _jquery2.default)(this);
			var ns = 'lazy' + counter++;
			var isImg = $element.is('img');
			var isBg = !isImg && $element.data('image');
	
			if (isImg) {
				$element.attr('src', 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==');
			} else if (isBg) {
				$element.css('background-image', 'none');
			}
	
			var height = void 0;
			var offset = void 0;
	
			function setup() {
				height = $element.outerHeight();
				offset = $element.offset();
	
				check();
			}
	
			function check() {
				if (offset.top < $window.scrollTop() + viewportHeight) {
					ready.call($element);
					$window.off('.' + ns);
				}
			}
	
			setup();
	
			$window.on('load.' + ns + ' resize.' + ns, function (e) {
				return (0, _utilities.frame)(setup);
			});
			$window.on('scroll.' + ns, function (e) {
				return (0, _utilities.frame)(check);
			});
		});
	};
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _utilities = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clsReady = 'is-ready';
	
	var $window = (0, _jquery2.default)(window);
	var viewportHeight = $window.height();
	
	$window.on('resize', function (e) {
		return viewportHeight = $window.height();
	});
	
	function ready() {
		var $this = (0, _jquery2.default)(this);
		var src = $this.data('image') || $this.data('src') || $this.prop('src');
		var img = new Image();
	
		var isImg = $this.is('img');
		var isBg = !isImg && $this.data('image');
	
		img.onload = function () {
			if (isImg) {
				$this.prop('src', src);
			} else if (isBg) {
				$this.css('background-image', 'url(' + src + ')');
			}
	
			$this.addClass(clsReady);
		};
	
		img.src = src;
	}

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.frame = frame;
	exports.unframe = unframe;
	exports.redraw = redraw;
	exports.isTouch = isTouch;
	exports.isIE = isIE;
	exports.dependency = dependency;
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Requests an animation frame.
	 *
	 * @param callback
	 * @returns {*}
	 */
	function frame(callback) {
		if (typeof requestAnimationFrame == 'undefined') {
			return setTimeout(callback, 0);
		}
	
		return requestAnimationFrame(callback);
	}
	
	/**
	 * Cancels a frame request.
	 *
	 * @param id
	 */
	function unframe(id) {
		if (typeof cancelAnimationFrame == 'undefined') {
			return clearTimeout(id);
		}
	
		return cancelAnimationFrame(id);
	}
	
	/**
	 * Triggers a layout reflow for a specific element.
	 *
	 * @param element
	 */
	function redraw(element) {
		if (element instanceof _jquery2.default) {
			element = element[0];
		}
	
		// Accessing this property triggers a layout reflow
		element.offsetWidth;
	}
	
	/**
	 * Crude check to see if the device is a touch screen.
	 *
	 * @returns {boolean}
	 */
	function isTouch() {
		// @see http://stackoverflow.com/a/4819886/556609
		return 'ontouchstart' in window || !!navigator.maxTouchPoints;
	}
	
	/**
	 * Crude check to see if the browser is IE.
	 *
	 * @param version - Optionally check a specific version (11, 10, or 9)
	 * @returns {boolean}
	 */
	function isIE() {
		var version = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
	
		var ua = navigator.userAgent;
		var is11 = /rv:11.0/i.test(ua);
		var is10 = /MSIE 10/i.test(ua);
		var is9 = /MSIE 9/i.test(ua);
	
		switch (version) {
			case 11:
				return is11;
			case 10:
				return is10;
			case 9:
				return is9;
		}
	
		return is11 && is10 && is9;
	}
	
	/**
	 * Loads an external Javascript file and executes it
	 *
	 * @param url - The URL to the Javascript file
	 * @param callback - A function to call after the script has been executed
	 * @param check - An optional function to return a boolean for manually checking if the script has correctly executed.
	 *   This ensures that the callback actually happens after the script has been executed. For example, if loading jQuery
	 *   this function could check whether the jQuery property exists on the window object.
	 */
	var loadedDependencies = null;
	function dependency(url) {
		var callback = arguments.length <= 1 || arguments[1] === undefined ? function () {} : arguments[1];
		var check = arguments.length <= 2 || arguments[2] === undefined ? function () {
			return true;
		} : arguments[2];
	
		if (!loadedDependencies) {
			loadedDependencies = {};
	
			(0, _jquery2.default)('script[src]').each(function () {
				var src = (0, _jquery2.default)(this).prop('src');
				loadedDependencies[src] = 1;
			});
		}
	
		var poll = function poll() {
			if (check()) {
				callback();
			} else {
				setTimeout(poll, 20);
			}
		};
	
		if (!loadedDependencies[url]) {
			loadedDependencies[url] = 1;
	
			_jquery2.default.getScript(url, poll);
		} else {
			poll();
		}
	}

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		var context = arguments.length <= 0 || arguments[0] === undefined ? document.body : arguments[0];
	
		var $context = (0, _jquery2.default)(context);
		(0, _autosize2.default)($context.find('textarea[data-autosize]'));
	};
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _autosize = __webpack_require__(21);
	
	var _autosize2 = _interopRequireDefault(_autosize);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Autosize 3.0.15
		license: MIT
		http://www.jacklmoore.com/autosize
	*/
	(function (global, factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
			factory(exports, module);
		} else {
			var mod = {
				exports: {}
			};
			factory(mod.exports, mod);
			global.autosize = mod.exports;
		}
	})(this, function (exports, module) {
		'use strict';
	
		var set = typeof Set === 'function' ? new Set() : (function () {
			var list = [];
	
			return {
				has: function has(key) {
					return Boolean(list.indexOf(key) > -1);
				},
				add: function add(key) {
					list.push(key);
				},
				'delete': function _delete(key) {
					list.splice(list.indexOf(key), 1);
				} };
		})();
	
		var createEvent = function createEvent(name) {
			return new Event(name);
		};
		try {
			new Event('test');
		} catch (e) {
			// IE does not support `new Event()`
			createEvent = function (name) {
				var evt = document.createEvent('Event');
				evt.initEvent(name, true, false);
				return evt;
			};
		}
	
		function assign(ta) {
			var _ref = arguments[1] === undefined ? {} : arguments[1];
	
			var _ref$setOverflowX = _ref.setOverflowX;
			var setOverflowX = _ref$setOverflowX === undefined ? true : _ref$setOverflowX;
			var _ref$setOverflowY = _ref.setOverflowY;
			var setOverflowY = _ref$setOverflowY === undefined ? true : _ref$setOverflowY;
	
			if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || set.has(ta)) return;
	
			var heightOffset = null;
			var overflowY = null;
			var clientWidth = ta.clientWidth;
	
			function init() {
				var style = window.getComputedStyle(ta, null);
	
				overflowY = style.overflowY;
	
				if (style.resize === 'vertical') {
					ta.style.resize = 'none';
				} else if (style.resize === 'both') {
					ta.style.resize = 'horizontal';
				}
	
				if (style.boxSizing === 'content-box') {
					heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
				} else {
					heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
				}
				// Fix when a textarea is not on document body and heightOffset is Not a Number
				if (isNaN(heightOffset)) {
					heightOffset = 0;
				}
	
				update();
			}
	
			function changeOverflow(value) {
				{
					// Chrome/Safari-specific fix:
					// When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
					// made available by removing the scrollbar. The following forces the necessary text reflow.
					var width = ta.style.width;
					ta.style.width = '0px';
					// Force reflow:
					/* jshint ignore:start */
					ta.offsetWidth;
					/* jshint ignore:end */
					ta.style.width = width;
				}
	
				overflowY = value;
	
				if (setOverflowY) {
					ta.style.overflowY = value;
				}
	
				resize();
			}
	
			function resize() {
				var htmlTop = window.pageYOffset;
				var bodyTop = document.body.scrollTop;
				var originalHeight = ta.style.height;
	
				ta.style.height = 'auto';
	
				var endHeight = ta.scrollHeight + heightOffset;
	
				if (ta.scrollHeight === 0) {
					// If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
					ta.style.height = originalHeight;
					return;
				}
	
				ta.style.height = endHeight + 'px';
	
				// used to check if an update is actually necessary on window.resize
				clientWidth = ta.clientWidth;
	
				// prevents scroll-position jumping
				document.documentElement.scrollTop = htmlTop;
				document.body.scrollTop = bodyTop;
			}
	
			function update() {
				var startHeight = ta.style.height;
	
				resize();
	
				var style = window.getComputedStyle(ta, null);
	
				if (style.height !== ta.style.height) {
					if (overflowY !== 'visible') {
						changeOverflow('visible');
					}
				} else {
					if (overflowY !== 'hidden') {
						changeOverflow('hidden');
					}
				}
	
				if (startHeight !== ta.style.height) {
					var evt = createEvent('autosize:resized');
					ta.dispatchEvent(evt);
				}
			}
	
			var pageResize = function pageResize() {
				if (ta.clientWidth !== clientWidth) {
					update();
				}
			};
	
			var destroy = (function (style) {
				window.removeEventListener('resize', pageResize, false);
				ta.removeEventListener('input', update, false);
				ta.removeEventListener('keyup', update, false);
				ta.removeEventListener('autosize:destroy', destroy, false);
				ta.removeEventListener('autosize:update', update, false);
				set['delete'](ta);
	
				Object.keys(style).forEach(function (key) {
					ta.style[key] = style[key];
				});
			}).bind(ta, {
				height: ta.style.height,
				resize: ta.style.resize,
				overflowY: ta.style.overflowY,
				overflowX: ta.style.overflowX,
				wordWrap: ta.style.wordWrap });
	
			ta.addEventListener('autosize:destroy', destroy, false);
	
			// IE9 does not fire onpropertychange or oninput for deletions,
			// so binding to onkeyup to catch most of those events.
			// There is no way that I know of to detect something like 'cut' in IE9.
			if ('onpropertychange' in ta && 'oninput' in ta) {
				ta.addEventListener('keyup', update, false);
			}
	
			window.addEventListener('resize', pageResize, false);
			ta.addEventListener('input', update, false);
			ta.addEventListener('autosize:update', update, false);
			set.add(ta);
	
			if (setOverflowX) {
				ta.style.overflowX = 'hidden';
				ta.style.wordWrap = 'break-word';
			}
	
			init();
		}
	
		function destroy(ta) {
			if (!(ta && ta.nodeName && ta.nodeName === 'TEXTAREA')) return;
			var evt = createEvent('autosize:destroy');
			ta.dispatchEvent(evt);
		}
	
		function update(ta) {
			if (!(ta && ta.nodeName && ta.nodeName === 'TEXTAREA')) return;
			var evt = createEvent('autosize:update');
			ta.dispatchEvent(evt);
		}
	
		var autosize = null;
	
		// Do nothing in Node.js environment and IE8 (or lower)
		if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
			autosize = function (el) {
				return el;
			};
			autosize.destroy = function (el) {
				return el;
			};
			autosize.update = function (el) {
				return el;
			};
		} else {
			autosize = function (el, options) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], function (x) {
						return assign(x, options);
					});
				}
				return el;
			};
			autosize.destroy = function (el) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], destroy);
				}
				return el;
			};
			autosize.update = function (el) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], update);
				}
				return el;
			};
		}
	
		module.exports = autosize;
	});

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _base = __webpack_require__(6);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// The class names of the various states the float label can have
	var classes = {
		input: '-type-input',
		select: '-type-select',
		textarea: '-type-textarea',
		focused: 'is-focused',
		filled: 'is-filled',
		invalid: 'is-invalid',
		scrolled: 'is-scrolled'
	};
	
	/**
	 * Applies the correct class names to the field
	 * @param e - The event object
	 */
	function setState(e) {
		var field = (0, _jquery2.default)(this);
	
		if (field.is('input[type="file"]')) {
			var div = field.siblings('div');
			var fileName = '';
	
			if (this.files && this.files.length > 1) {
				fileName = this.files.length + ' files selected';
			} else {
				fileName = this.value.split('\\').pop();
			}
	
			div.html(fileName);
		}
	
		// Wrap within an instantaneous timeout so state changes can be detected on the next redraw. This fixes a
		// problem with the "keydown" event in that the key value is added to the field after the event has been
		// called. This means the value of the field returned will be the previous value. The timeout ensures that
		// the input happens before the value is checked.
		setTimeout(function () {
			field.closest(FloatLabel.getSelector())
	
			// Set the field type as a class to the float label wrapper
			.addClass(classes[field.prop('tagName').toLowerCase()])
	
			// Is the element in focus?
			.toggleClass(classes.focused, e.type == 'focus' || field.is(':focus'))
	
			// Check if the fields value is an empty string. This works for select options that have an empty
			// value. This can be exploited by creating an empty option, disabling it and setting it as the
			// default.
			.toggleClass(classes.filled, !!field.val())
	
			// Only apply if browser supports field validation
			.toggleClass(classes.invalid, field[0].validity ? !field[0].validity.valid : false)
	
			// Specifically for textarea's. This is useful so that the label can be hidden when the content is
			// scrolled, so that the label and the fields text don't overlap and look ugly.
			.toggleClass(classes.scrolled, field.scrollTop() > 0);
		});
	}
	
	var FloatLabel = _base2.default.extend({
		directive: 'float-label',
	
		events: {
	
			init: function init() {
				(0, _jquery2.default)(this.$element).find('input, select, textarea')
	
				// Add events to fields
				.on('focus blur change keyup keydown scroll', setState)
	
				// Set states on the page load.
				.each(setState);
			}
		}
	});
	
	exports.default = FloatLabel;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _base = __webpack_require__(6);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _utilities = __webpack_require__(19);
	
	var _init = __webpack_require__(15);
	
	var _init2 = _interopRequireDefault(_init);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var parsleyDir = 'https://cdnjs.cloudflare.com/ajax/libs/parsley.js/2.5.1/';
	
	exports.default = _base2.default.extend({
		directive: 'form-validator',
	
		defaults: {},
	
		events: {
	
			init: function init() {
				var _this = this;
	
				(0, _utilities.dependency)(parsleyDir + 'parsley.min.js', function () {
					var $element = (0, _jquery2.default)(_this.$element);
					var parsley = $element.parsley();
	
					parsley.on('field:validated', function (e) {
						// Make sure errors reported by the server get removed
						$element.siblings('.float-label_errors').remove();
					});
				}, function () {
					return window.Parsley;
				});
			}
		}
	});

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _config = __webpack_require__(3);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _base = __webpack_require__(6);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _base2.default.extend({
		directive: 'sticky',
	
		defaults: {
			name: '',
			offset: 0,
			classStuck: 'is-stuck',
			classUnstuck: 'is-unstuck'
		},
	
		events: {
	
			init: function init() {
				var sticky = (0, _jquery2.default)(this.$element);
				var filler = (0, _jquery2.default)('<div ' + _config2.default.directivePrefix + 'sticky-filler="' + this.$settings.name + '">');
				var $window = (0, _jquery2.default)(window);
				var offset = this.$settings.offset;
				var clsStuck = this.$settings.classStuck;
				var clsUnstuck = this.$settings.classUnstuck;
	
				var isFixed = false;
	
				sticky.before(filler);
	
				function fillerSize() {
					filler.css('height', sticky.outerHeight() + 'px');
				}
	
				function stickyScroll() {
					if (isFixed) {
						var fillerTop = filler.offset().top + offset;
	
						if ($window.scrollTop() <= fillerTop) {
							isFixed = false;
							fixSticky(false);
						}
					} else {
						var stickyTop = sticky.offset().top + offset;
	
						if ($window.scrollTop() > stickyTop) {
							isFixed = true;
							fixSticky(true);
						}
					}
				}
	
				function fixSticky(fix) {
					if (fix) {
						filler.css('display', '');
						sticky.addClass(clsStuck);
						sticky.removeClass(clsUnstuck);
					} else {
						filler.css('display', 'none');
						sticky.removeClass(clsStuck);
						sticky.addClass(clsUnstuck);
					}
				}
	
				fillerSize();
				fixSticky(false);
				stickyScroll();
	
				$window.on('resize', fillerSize);
				$window.on('resize scroll', stickyScroll);
			}
		}
	});

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _base = __webpack_require__(6);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $window = (0, _jquery2.default)(window);
	
	exports.default = _base2.default.extend({
		directive: 'scroll-marker',
	
		modules: {
	
			items: _base2.default.extend({
				directive: 'scroll-marker-item',
	
				defaults: {
					target: '',
					classSelected: 'is-selected'
				},
	
				events: {
	
					init: function init() {
						var target = this.$settings.target;
	
						this.target = (0, _jquery2.default)('[scroll-marker-rel="' + target + '"]');
					}
				},
	
				methods: {
	
					observeDelta: function observeDelta() {
						return this.target.offset().top - $window.scrollTop();
					},
	
					toggle: function toggle() {
						var select = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
	
						select = typeof select === 'boolean' ? select : !this.target.hasClass(this.$settings.classSelected);
	
						this.target.add(this.$element).toggleClass(this.$settings.classSelected, select);
					},
	
					select: function select() {
						this.toggle(true);
					},
	
					unselect: function unselect() {
						this.toggle(false);
					}
				}
			})
		},
	
		events: {
	
			init: function init() {
				var _this = this;
	
				$window.on('resize scroll', function (e) {
					var closestItem = null;
					var closestDistance = null;
	
					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;
	
					try {
						for (var _iterator = _this.$owns.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var item = _step.value;
	
							item.unselect();
	
							if (!closestItem) {
								closestItem = item;
								closestDistance = Math.abs(item.observeDelta());
							} else {
								var distance = Math.abs(item.observeDelta());
	
								if (distance < closestDistance) {
									closestItem = item;
									closestDistance = distance;
								}
							}
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}
	
					if (closestItem) {
						closestItem.select();
					}
				});
			}
		}
	});

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _base = __webpack_require__(6);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _utilities = __webpack_require__(19);
	
	var _init = __webpack_require__(15);
	
	var _init2 = _interopRequireDefault(_init);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var swiperDir = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/3.3.1/';
	var addedCss = false;
	
	exports.default = _base2.default.extend({
		directive: 'swiper',
	
		defaults: {
			loop: true,
			preloadImages: false,
			lazyLoading: true,
			lazyLoadingInPrevNext: true,
			paginationElement: 'button',
			paginationClickable: true,
			runCallbacksOnInit: true
		},
	
		events: {
	
			init: function init() {
				var _this = this;
	
				if (!addedCss) {
					(0, _jquery2.default)('head').append('<link rel="stylesheet" href="' + swiperDir + 'css/swiper.min.css">');
					addedCss = true;
				}
	
				(0, _utilities.dependency)(swiperDir + 'js/swiper.min.js', function () {
					var $element = (0, _jquery2.default)(_this.$element);
					var $slides = $element.find('.swiper-slide');
					var swiper = $slides.length > 1 ? new Swiper(_this.$element, _this.$settings) : false;
	
					if ($element.hasClass('slideshow') && $element.hasClass('-fit-image')) {
						(function () {
							var getHeight = function getHeight() {
								var maxHeight = 0;
	
								$element.find('.slideshow_slide_content').each(function () {
									var $this = (0, _jquery2.default)(this);
									var paddingTop = parseFloat($this.css('padding-top').replace('px', ''));
									var paddingBottom = parseFloat($this.css('padding-bottom').replace('px', ''));
									var innerHeight = $this.children().height();
	
									maxHeight = Math.max(maxHeight, innerHeight + paddingTop + paddingBottom);
								});
	
								return maxHeight;
							};
	
							var setHeight = function setHeight() {
								var minHeight = getHeight();
	
								$element.find('.slideshow_slide_background').css('min-height', minHeight + 'px');
	
								$element.find('.slideshow_slide_background .media').each(function () {
									var $this = (0, _jquery2.default)(this);
									var height = $this.height();
	
									$this.css('transform', height < minHeight ? 'scale(' + minHeight / height + ')' : '');
								});
							};
	
							(0, _jquery2.default)(function (e) {
								return (0, _utilities.frame)(setHeight);
							});
							(0, _jquery2.default)(window).on('load resize', function (e) {
								return (0, _utilities.frame)(setHeight);
							});
	
							if (swiper) {
								swiper.on('slideChangeStart', setHeight);
								swiper.on('slideChangeEnd', setHeight);
							}
	
							setHeight();
						})();
					}
	
					if (swiper) {
						swiper.on('slideChangeStart', function (e) {
							return $element.find('.swiper-slide-duplicate').each(function () {
								var $slide = (0, _jquery2.default)(this);
	
								if ($slide.hasClass('swiper-slide-active') && !$slide.data('init')) {
									(0, _init2.default)(this);
									$slide.data('init', true);
								}
							});
						});
					}
	
					$element.addClass('swiper-ready');
				}, function () {
					return window.Swiper;
				});
			}
		}
	});

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _base = __webpack_require__(6);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _toggler = __webpack_require__(4);
	
	var _toggler2 = _interopRequireDefault(_toggler);
	
	var _init = __webpack_require__(15);
	
	var _init2 = _interopRequireDefault(_init);
	
	var _utilities = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $body = (0, _jquery2.default)(document.body);
	
	exports.default = _toggler2.default.extend({
		directive: 'lightbox',
	
		defaults: {
			event: 'click',
			content: ''
		},
	
		methods: {
			_setup: function _setup() {
				var _this = this;
	
				$body.append(this.$lightbox);
	
				// Close the lightbox if clicked on the background
				this.$lightbox.on('click', function (e) {
					if (e.target === _this.$lightbox[0]) {
						_this.close();
					}
				});
	
				var that = this;
				this.$lightbox.find('[lightbox-action]').on('click', function () {
					var $this = (0, _jquery2.default)(this);
					var action = $this.attr('lightbox-action');
	
					switch (action) {
						case 'close':
							{
								that.close();
								break;
							}
					}
				});
	
				(0, _init2.default)(this.$lightbox[0]);
			},
			open: function open() {
				if (!this._hasSetup) {
					this._setup();
					this._hasSetup = true;
	
					this.$lightbox.css('display', 'none');
					(0, _utilities.redraw)(this.$lightbox[0]);
				}
	
				this.$lightbox.fadeIn();
			},
			close: function close() {
				var _this2 = this;
	
				this.$lightbox.fadeOut({
					complete: function complete(e) {
						_this2.$lightbox.remove();
						_this2._hasSetup = false;
					}
				});
			}
		},
	
		events: {
			init: function init() {
				var _this3 = this;
	
				var $element = (0, _jquery2.default)(this.$element);
				this.$lightbox = (0, _jquery2.default)(this.$settings.content);
	
				$element.on(this.$settings.event, function (e) {
					e.preventDefault();
	
					_this3.open();
				});
			}
		}
	});

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _base = __webpack_require__(6);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _utilities = __webpack_require__(19);
	
	var _style = __webpack_require__(29);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Map = _base2.default.extend({
		directive: 'map',
	
		defaults: {
			apiKey: '',
			lat: 0,
			lng: 0,
			zoom: 0,
			marker: false,
			control: false,
			title: ''
		},
	
		modules: {
	
			markers: _base2.default.extend({
				directive: 'marker',
	
				defaults: {
					lat: 0,
					lng: 0,
					title: false,
					url: false
				},
	
				methods: {
					setup: function setup() {
						var _this = this;
	
						var MapLabel = __webpack_require__(30).default;
	
						var markerSettings = this.$settings;
						var markerPoint = new google.maps.LatLng(markerSettings.lat, markerSettings.lng);
						var infoContent = this.$element.innerHTML.trim();
						var mapMarker = new google.maps.Marker({
							map: this.$owner.map,
							position: markerPoint,
							title: markerSettings.title || ''
						});
	
						this.point = markerPoint;
						this.marker = mapMarker;
	
						if (markerSettings.url) {
							mapMarker.addListener('click', function (e) {
								return window.open(markerSettings.url, '_blank');
							});
						} else if (infoContent) {
							(function () {
								var markerInfo = new google.maps.InfoWindow({
									content: infoContent
								});
	
								_this.info = markerInfo;
								_this.$owner.mapMarkerInfos.push(markerInfo);
	
								mapMarker.addListener('click', function (e) {
									var _iteratorNormalCompletion = true;
									var _didIteratorError = false;
									var _iteratorError = undefined;
	
									try {
										for (var _iterator = _this.$owner.mapMarkerInfos[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
											var info = _step.value;
	
											info.close();
										}
									} catch (err) {
										_didIteratorError = true;
										_iteratorError = err;
									} finally {
										try {
											if (!_iteratorNormalCompletion && _iterator.return) {
												_iterator.return();
											}
										} finally {
											if (_didIteratorError) {
												throw _iteratorError;
											}
										}
									}
	
									markerInfo.open(_this.$owner.map, mapMarker);
								});
							})();
						}
	
						if (this.$owner.$settings.marker && !(0, _utilities.isIE)()) {
							mapMarker.setIcon(this.$owner.$settings.marker);
						}
	
						if (this.$element.nodeName.toLowerCase() === 'a') {
							google.maps.event.addListener(mapMarker, 'click', function () {
								window.location.href = this.$element.getAttribute('href');
							});
						}
	
						var label = new MapLabel({ map: this.$owner.map });
						label.bindTo('position', mapMarker, 'position');
						label.bindTo('text', mapMarker, 'title');
					}
				}
			}),
	
			searchers: _base2.default.extend({
				directive: 'search',
	
				defaults: {
					zoom: 13
				},
	
				methods: {
					setup: function setup() {
						var _this2 = this;
	
						var map = this.$owner.map;
	
						var $this = (0, _jquery2.default)(this.$element);
	
						var $input = $this.is('input') ? $this : $this.find('input[name="map-search"]');
						var input = $input[0];
						var searchText = $input.val();
	
						var $form = (0, _jquery2.default)(input.form);
						var form = $form[0];
	
						var searchBox = new google.maps.places.SearchBox(input);
	
						input.setAttribute('placeholder', '');
	
						// Bias the SearchBox results towards current map's viewport.
						map.addListener('bounds_changed', function (e) {
							return searchBox.setBounds(map.getBounds());
						});
	
						var findClosestMarkers = function findClosestMarkers(latLng) {
							latLng = new google.maps.LatLng(latLng.lat, latLng.lng);
	
							var closestMarkers = _this2.$owner.$owns.markers.slice();
							closestMarkers.sort(function (a, b) {
								var aDist = google.maps.geometry.spherical.computeDistanceBetween(a.point, latLng);
								var bDist = google.maps.geometry.spherical.computeDistanceBetween(b.point, latLng);
	
								return aDist - bDist;
							});
	
							return closestMarkers;
						};
	
						var updateLocation = function updateLocation() {
							var places = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
	
							places = places || searchBox.getPlaces();
	
							if (places && places.length > 0) {
								var place = places[0];
								var closestMarkers = findClosestMarkers({
									lat: place.geometry.location.lat(),
									lng: place.geometry.location.lng()
								});
								var closestMarker = closestMarkers[0];
	
								map.panTo(closestMarker.point);
								map.setZoom(_this2.$settings.zoom);
	
								// Open info window
								if (closestMarker.info) {
									closestMarker.info.open(map, closestMarker.marker);
								}
	
								_this2.$owner.$settings.lat = closestMarker.point.lat;
								_this2.$owner.$settings.lng = closestMarker.point.lng;
								_this2.$owner.$settings.zoom = _this2.$settings.zoom;
							}
						};
	
						$form.on('submit', function (e) {
							e.preventDefault(), updateLocation();
						});
						searchBox.addListener('places_changed', updateLocation);
	
						if (searchText) {
							google.maps.event.addListenerOnce(map, 'idle', function () {
								var places = new google.maps.places.PlacesService(map);
								places.textSearch({ bounds: map.getBounds(), query: searchText }, updateLocation);
							});
						}
					}
				}
			})
		},
	
		events: {
	
			init: function init() {
				var _this3 = this;
	
				var apiUrl = 'https://maps.googleapis.com/maps/api/js?libraries=geometry,places&key=' + this.$settings.apiKey;
	
				// Convert the zoom to an integer so Google doesn't complain
				this.$settings.zoom = this.$settings.zoom | 0;
	
				(0, _utilities.dependency)(apiUrl, function () {
					var point = new google.maps.LatLng(_this3.$settings.lat, _this3.$settings.lng);
	
					_this3.map = new google.maps.Map(_this3.$element, {
						center: point,
						zoom: _this3.$settings.zoom,
						mapTypeId: google.maps.MapTypeId.ROADMAP,
						scrollwheel: false,
						streetViewControl: false,
						draggable: _this3.$settings.control,
						panControl: false,
						overviewMapControl: false,
						zoomControl: _this3.$settings.control,
						mapTypeControl: false,
						disableDefaultUI: true,
						disableDoubleClickZoom: true,
						styles: _style2.default
					});
	
					_this3.mapMarkerInfos = [];
	
					var _iteratorNormalCompletion2 = true;
					var _didIteratorError2 = false;
					var _iteratorError2 = undefined;
	
					try {
						for (var _iterator2 = _this3.$owns.markers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
							var marker = _step2.value;
	
							marker.setup();
						}
					} catch (err) {
						_didIteratorError2 = true;
						_iteratorError2 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion2 && _iterator2.return) {
								_iterator2.return();
							}
						} finally {
							if (_didIteratorError2) {
								throw _iteratorError2;
							}
						}
					}
	
					var _iteratorNormalCompletion3 = true;
					var _didIteratorError3 = false;
					var _iteratorError3 = undefined;
	
					try {
						for (var _iterator3 = _this3.$owns.searchers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
							var search = _step3.value;
	
							search.setup();
						}
					} catch (err) {
						_didIteratorError3 = true;
						_iteratorError3 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion3 && _iterator3.return) {
								_iterator3.return();
							}
						} finally {
							if (_didIteratorError3) {
								throw _iteratorError3;
							}
						}
					}
	
					(0, _jquery2.default)(window).on('resize', function (e) {
						_this3.map.setCenter(point);
						_this3.map.setZoom(_this3.$settings.zoom);
	
						_this3.autoZoom();
					});
	
					google.maps.event.addListenerOnce(_this3.map, 'idle', function () {
						return _this3.autoZoom();
					});
				}, function () {
					return window.google && google.maps;
				});
			}
		},
	
		methods: {
			autoZoom: function autoZoom() {
				var containsAllMarkers = true;
	
				var mapBounds = this.map.getBounds();
				var bounds = new google.maps.LatLngBounds();
	
				var _iteratorNormalCompletion4 = true;
				var _didIteratorError4 = false;
				var _iteratorError4 = undefined;
	
				try {
					for (var _iterator4 = this.$owns.markers[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
						var marker = _step4.value;
	
						var markerPoint = new google.maps.LatLng(marker.$settings.lat, marker.$settings.lng);
	
						containsAllMarkers = containsAllMarkers && mapBounds.contains(markerPoint);
						bounds.extend(markerPoint);
					}
				} catch (err) {
					_didIteratorError4 = true;
					_iteratorError4 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion4 && _iterator4.return) {
							_iterator4.return();
						}
					} finally {
						if (_didIteratorError4) {
							throw _iteratorError4;
						}
					}
				}
	
				if (!containsAllMarkers && this.$settings.zoom) {
					this.map.fitBounds(bounds);
	
					if (this.map.getZoom() > this.$settings.zoom) {
						this.map.setZoom(this.$settings.zoom);
					}
				}
			}
		}
	});
	
	exports.default = Map;

/***/ },
/* 29 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = [{
		// stylers: [ {saturation: -100 } ]
	}];

/***/ },
/* 30 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_ref) {
		_inherits(_class, _ref);
	
		function _class(opt_options) {
			_classCallCheck(this, _class);
	
			// Initialization
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(_class).call(this));
	
			_this.setValues(opt_options);
	
			// Label specific
			var span = _this.span_ = document.createElement('span');
			span.style.cssText = 'position:relative;left:-50%;white-space:nowrap';
	
			var div = _this.div_ = document.createElement('div');
			div.appendChild(span);
			div.style.cssText = 'position:absolute;display:none';
			return _this;
		}
	
		_createClass(_class, [{
			key: 'onAdd',
			value: function onAdd() {
				var pane = this.getPanes().overlayLayer;
				pane.appendChild(this.div_);
	
				// Ensures the label is redrawn if the text or position is changed.
				var me = this;
				this.listeners_ = [google.maps.event.addListener(this, 'position_changed', function (e) {
					return me.draw();
				}), google.maps.event.addListener(this, 'text_changed', function (e) {
					return me.draw();
				})];
			}
		}, {
			key: 'onRemove',
			value: function onRemove() {
				this.div_.parentNode.removeChild(this.div_);
	
				// Label is removed from the map, stop updating its position/text.
				for (var i = 0, I = this.listeners_.length; i < I; ++i) {
					google.maps.event.removeListener(this.listeners_[i]);
				}
			}
		}, {
			key: 'draw',
			value: function draw() {
				var projection = this.getProjection();
				var position = projection.fromLatLngToDivPixel(this.get('position'));
	
				var div = this.div_;
				div.style.left = position.x + 'px';
				div.style.top = position.y + 'px';
				div.style.display = 'block';
	
				this.span_.innerHTML = this.get('text').toString();
			}
		}]);
	
		return _class;
	}(window.google ? google.maps.OverlayView : {});
	
	exports.default = _class;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _utilities = __webpack_require__(19);
	
	var _base = __webpack_require__(6);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $window = (0, _jquery2.default)(window);
	var viewportHeight = $window.height();
	
	$window.on('resize', function (e) {
		return viewportHeight = $window.height();
	});
	
	exports.default = _base2.default.extend({
		directive: 'parallax',
	
		defaults: {
			speed: 1,
			scale: false
		},
	
		events: {
	
			init: function init() {
				// Disable for touch-screen devices
				if ((0, _utilities.isTouch)()) return;
	
				var $element = (0, _jquery2.default)(this.$element);
				var scale = this.$settings.scale;
				var speed = Math.max(0, Math.min(parseFloat(this.$settings.speed), 1));
	
				var height = void 0;
				var offset = void 0;
	
				function setup() {
					$element.css('transform', '');
					$element.css('height', '');
	
					(0, _utilities.redraw)($element);
	
					height = $element.outerHeight();
					offset = $element.offset();
	
					if (scale) {
						var viewHeight = Math.min(viewportHeight, offset.top + height);
						var newHeight = viewHeight - (viewHeight - height) * speed;
						$element.css('height', newHeight + 'px');
					}
	
					position();
				}
	
				function position() {
					var translate = 0;
	
					if (scale) {
						translate = ($window.scrollTop() - offset.top) * (speed - 1);
					} else {
						translate = ($window.scrollTop() - offset.top + (viewportHeight - height) / 2) * (speed - 1);
					}
	
					$element.css('transform', 'translate3d(0, ' + -translate + 'px, 0)');
				}
	
				setup();
	
				var resizeId = void 0;
				(0, _jquery2.default)(function (e) {
					(0, _utilities.unframe)(resizeId);
					resizeId = (0, _utilities.frame)(setup);
				});
				$window.on('load resize', function (e) {
					(0, _utilities.unframe)(resizeId);
					resizeId = (0, _utilities.frame)(setup);
				});
	
				var scrollId = void 0;
				$window.on('scroll', function (e) {
					(0, _utilities.unframe)(scrollId);
					resizeId = (0, _utilities.frame)(position);
				});
			}
		}
	});

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _utilities = __webpack_require__(19);
	
	var _base = __webpack_require__(6);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $window = (0, _jquery2.default)(window);
	var viewportHeight = $window.height();
	
	$window.on('resize', function (e) {
		return viewportHeight = $window.height();
	});
	
	exports.default = _base2.default.extend({
		directive: 'scroll-fader',
	
		defaults: {
			offset: 1,
			distance: 0.1
		},
	
		events: {
	
			init: function init() {
				// Disable for touch-screen devices
				if ((0, _utilities.isTouch)()) return;
	
				var $element = (0, _jquery2.default)(this.$element);
				var offset = Math.max(0, Math.min(parseFloat(this.$settings.offset), 1));
				var distance = Math.max(0, Math.min(parseFloat(this.$settings.distance), 1));
	
				var height = void 0;
				var position = void 0;
	
				function setup() {
					height = $element.outerHeight();
					position = $element.offset();
	
					update();
				}
	
				function update() {
					var scrollTop = $window.scrollTop();
					var scrollDistance = viewportHeight * distance;
	
					var opacity = 1;
	
					// TODO
	
					$element.css('opacity', opacity);
				}
	
				setup();
	
				var resizeId = void 0;
				$window.on('load resize', function (e) {
					(0, _utilities.unframe)(resizeId);
					resizeId = (0, _utilities.frame)(setup);
				});
	
				var scrollId = void 0;
				$window.on('scroll', function (e) {
					(0, _utilities.unframe)(scrollId);
					resizeId = (0, _utilities.frame)(update);
				});
			}
		}
	});

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _toggler = __webpack_require__(4);
	
	var _toggler2 = _interopRequireDefault(_toggler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _toggler2.default.extend({
		directive: 'notification',
	
		defaults: {
			duration: 0 // How many days to hide the notification banner for after it's closed
		},
	
		events: {
	
			beforeInit: function beforeInit(e) {
				var closed = false;
	
				if (e.settings.duration > 0) {
					if (localStorage.notified) {
						var delta = Date.now() - localStorage.notified;
						var msDuration = e.settings.duration * 24 * 60 * 60 * 1000;
	
						if (delta >= msDuration) {
							delete localStorage.notified;
						} else {
							closed = true;
						}
					}
				} else {
					if (localStorage.notified) {
						closed = true;
					}
				}
	
				e.settings.is = closed ? 'closed' : 'open';
			},
	
			init: function init() {
				this.on('change', function () {
					if (this.isClosed() && !localStorage.notified) {
						localStorage.notified = Date.now();
					}
				});
			},
	
			action: function action(e) {
				if (e.event.type == 'submit') {
					e.stopPropagation = true;
				}
			}
		}
	});

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** main.js
 **/